import { TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { toTwoDecimals } from "../../../components/NewDetail/calculations/utils";

const OrderTableRow = ({ onSelect, order }) => {
  return (
    <TableRow hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.id}
      </TableCell>

      <TableCell
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.project.name}
      </TableCell>

      <TableCell
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.company.creditType}
      </TableCell>

      <TableCell
        align="right"
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.estimateLastSentForApproval
          ? moment(order.estimateLastSentForApproval).format("MM/DD/YY")
          : "N/A"}
      </TableCell>

      <TableCell
        onClick={() => {
          onSelect(order);
        }}
      >
        {moment(order.estimateApprovalDate).format("MM/DD/YY")}
      </TableCell>
      <TableCell>${toTwoDecimals(order.outTheDoorCost)}</TableCell>
    </TableRow>
  );
};

export default OrderTableRow;
